// Dependencies
import React, { useState, useRef, useEffect } from "react";

// Modules
import { useSelector } from "react-redux";

// App
import { serverUrl, apiEndpoints } from "../../config";
import { getOnlineNode } from "../../core/getNode";
import PageHeader from "../../partials/pageHeader";
import Error from "../../partials/error";
import { alertMessages } from "../../partials/alertMessages";

// UI components
import { CircularProgress } from "@mui/material";
import SkeletonSingleScreen from "../../partials/skeleton-screens/skeletonSingleScreen";

export default function Contribute(props) {
  const [iframeLoading, setIframeLoading] = useState(true);
  const iframeRef = useRef(null);
  const user = useSelector((state) => state).authReducer.user;

  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    getOnlineNode(apiEndpoints.contribute, user.access_token)
      .then((response) => {
        console.log('response', response);
        if (response.data) {
          setData(response.data);
          setIsLoading(false);
        } else {
          _setError(true, 0, alertMessages.unkownError.message);
        }
      })
      .catch((_error) => {
        if (_error.response) {
          _setError(true, _error.response.status, _error.response.statusText);
        } else if (_error.request) {
          _setError(true, 0, alertMessages.requestError.message);
        } else {
          _setError(true, 0, alertMessages.unkownError.message);
        }
      });
    // eslint-disable-next-line
  }, []);

  /**
   * @function setError
   * @description Updates the state of the component upon an error
   * @param {boolean} _isError
   * @param {int} _errorStatus
   * @param {string} _errorMessage
   */
  const _setError = (_isError, _errorStatus, _errorMessage) => {
    setIsLoading(false);

    setIsError(_isError);
    setErrorStatus(_errorStatus);
    setErrorMessage(_errorMessage);
  };

  if (isLoading || !data) {
    console.log('data', data);
    return <SkeletonSingleScreen />;
  } else {
    return (
      <>
        {isError ? (
          <Error status={errorStatus} message={errorMessage} />
        ) : (
          <main className="contribute screen">
            <PageHeader
              pageName="Contribute"
              owner="client"
              pageNameColor="clientText.dark"
            />
            <div className="ratio ratio-4x3" style={{ height: "100vh" }}>
              {data?.webform && (
                <>
                  {iframeLoading && (
                    <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                      <CircularProgress />
                    </div>
                  )}
                  <iframe
                    className={`${iframeLoading && "invisible"}`}
                    src={`${serverUrl}/node/${data.nid[0].value}?app=true`}
                    ref={iframeRef}
                    style={{ width: "100%", height: "1080px", border: "none" }}
                    title="Iframe Content"
                    onLoad={(iframe) => {
                      setIframeLoading(false);
                    }}
                  />
                </>
              )}
            </div>
          </main>
        )}
      </>
    );
  }
}
